import * as React from 'react';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import { __t, applyTranslations } from 'utils/language';
import { isRequired } from 'utils/validators';

import './offer-additional-compensation-other.scss';

applyTranslations(require('../offer-additional-compensation.i18n.json'));

import type {
  OfferAdditionalCompensationOtherType,
  OfferAdditionalCompensationType
} from '../types';

interface Props {
  other: OfferAdditionalCompensationOtherType,
  onCheckboxChange: (
    identifier: OfferAdditionalCompensationType,
    isSelected: boolean
  ) => void,
  onInputChange: (
    identifier: OfferAdditionalCompensationType,
    field: string,
    value: string
  ) => void
}

const MSG_KEY = 'offer_additional_compensation';

const OfferAdditionalCompensationOther: React.FC<Props> = ({
  other,
  onCheckboxChange,
  onInputChange
}: Props) => {
  const handleCheckbox = (
    event: React.SyntheticEvent<HTMLInputElement>
  ): void => {
    const target = event.currentTarget;
    const selected = target.checked;

    onCheckboxChange('other', selected);
  };

  const handleInput = (
    event: React.SyntheticEvent<HTMLInputElement>
  ): void => {
    const target = event.currentTarget;
    const field = target.name;
    const value = target.value;

    onInputChange('other', field, value);
  };

  const renderCheckbox = (): React.ReactNode => (
    <div className="offer-additional-compensation-other__checkbox">
      <InputCheckbox
        id="offer-additional-compensation-other--checkbox"
        value="other"
        checked={other.isSelected}
        label={__t(`${MSG_KEY}.labels.other`)}
        onChange={handleCheckbox}
      />
    </div>
  );

  const renderDescription = (): React.ReactNode => {
    const description = other.description;
    let validators;

    if (other.isSelected) {
      validators = [
        isRequired(description, __t(`${MSG_KEY}.errors.other_details`))
      ];
    }

    return (
      <div className="offer-additional-compensation-other__description">
        <FormField
          direction="column"
          fontSize="small"
          showValidationIcon={false}
          validators={validators}
        >
          <Input
            name="description"
            value={description}
            width="responsive"
            placeholder={__t(`${MSG_KEY}.placeholders.nature_of_compensation`)}
            multiline
            onChange={handleInput}
          />
        </FormField>
      </div>
    );
  };

  return (
    <div className="offer-additional-compensation-other">
      {renderCheckbox()}
      {
        other.isSelected && (
          <div className="offer-additional-compensation-other__fields">
            {renderDescription()}
          </div>
        )
      }
    </div>
  );
};

export default OfferAdditionalCompensationOther;
